export default "__VITE_PUBLIC_ASSET__c89efb79__"